class paginationLoader extends HTMLElement {
  constructor() {
    super();
    this.skeletonTopLoader = document.querySelector('[data-skeleton-pagination-top]');
    this.skeletonBottomLoader = document.querySelector('[data-skeleton-pagination-bottom]');
    this.loadMoreButton = this.querySelector('.js-load-more');
    this.loadMoreButton.addEventListener('click', this.onLoadMoreClick.bind(this));
    this.totalPages = parseInt(this.querySelector('[data-total-pages]').value);
    this.inputNextUrl = this.querySelector('[data-next-url]');

    if (window.location.search && this.dataset.disableLoadPages != "true") {
      this.loadPages();
    }
  }

  async loadContent(nextUrl) {
    if (this.loading) return false;
    this.loading = true;
    this.loadMoreButton.disabled = true;
    this.loadMoreButton.classList.add('btn--loading');
    this.handleLoadingState(true, true);
    this.setAttribute('aria-busy', 'true');
    const error = this.querySelector('[data-pagination-error]');
    if (error) error.hidden = true;
    try {
      const response = await fetch(nextUrl);
      if (!response.ok) throw new Error('Unable to load results');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const source = html.getElementById('data-pagination');
      const target = document.getElementById('data-pagination');
      const total = html.querySelector('[data-total-pages]');
      const current = html.querySelector('[data-current-page]');
      const next = html.querySelector('[data-next-url]');
      if (!source || !target || !total || !current || !next) throw new Error('Incomplete results');
      const items = source.querySelectorAll('.data-pagination__item');
      if (!items.length) throw new Error('Missing result items');
      this.querySelector('[data-total-pages]').value = total.value;
      this.querySelector('[data-current-page]').value = current.value;
      this.inputNextUrl.value = next.value;
      document.querySelectorAll('input[name="page"]').forEach(input => { input.value = current.value; });
      // Keep Shopify image URLs intact; appending a timestamp corrupts their query/path.
      items.forEach(item => target.appendChild(item));
      this.loadMoreButton.classList.toggle('hide', !next.value || Number(current.value) >= Number(total.value));
      const focus = items[0].querySelector('a[href]');
      if (focus) focus.focus();
      return true;
    } catch (failure) {
      if (error) error.hidden = false;
      return false;
    } finally {
      this.loading = false;
      this.loadMoreButton.disabled = false;
      this.loadMoreButton.classList.remove('btn--loading');
      this.handleLoadingState(false, true);
      this.removeAttribute('aria-busy');
    }
  }

  async renderPage(urlParams, event, updateURLHash = true) {
    const url = `${window.location.pathname}?${urlParams}`;
    const loaded = await this.loadContent(url);

    if (loaded && typeof FacetFiltersForm !== 'undefined') FacetFiltersForm.searchParamsPrev = urlParams;
    if (loaded && updateURLHash) paginationLoader.updateURLHash(urlParams);
  }

  static updateURLHash(urlParams) {
    paginationLoader.urlParamsPrev = urlParams;
    history.pushState({ urlParams }, '', `${window.location.pathname}${urlParams && '?'.concat(urlParams)}`);
  }

  loadPages() {
    const params = getAllUrlParams(window.location.href);
    const page = params.page ? parseInt(params.page) : null;

    if (Number.isFinite(page) && page > 1 && page <= this.totalPages) {
      const currentUrl = `${window.location.pathname}${window.location.search}`;
      const pagesArray = Array.apply(null, Array(page - 1)).map(function (x, i) { return i; });
      const id = 'data-pagination';
      const productsElm = document.getElementById(id);
      const newDiv = document.createElement("div");
      this.loading = true;
      this.loadMoreButton.disabled = true;
      this.handleLoadingState(true);

      const promises = pagesArray.map((pageLoop) => {
        pageLoop = pageLoop + 1;
        const fetchUrl = currentUrl.replace(/page=[0-9]+/,'page='+ pageLoop);
        return fetch(fetchUrl)
          .then((response) => {
            if (!response.ok) throw new Error('Unable to restore results');
            return response.text();
          });
      });

      Promise.all(promises)
        .then((texts) => {
          texts.forEach((responseText) => {
            const htmlElm = new DOMParser().parseFromString(responseText, 'text/html');
            const sectionInnerHTML = htmlElm.getElementById(id);
            sectionInnerHTML.querySelectorAll('.data-pagination__item').forEach((elm) => {
              newDiv.appendChild(elm);
            });
          });
          productsElm.insertAdjacentHTML('afterbegin', newDiv.innerHTML);
          this.handleLoadingState(false);

          if (this.totalPages && page >= this.totalPages) {
            this.loadMoreButton.classList.add('hide');
          }
        }).catch(() => {
          const error = this.querySelector('[data-pagination-error]');
          if (error) error.hidden = false;
        }).finally(() => {
          this.loading = false;
          this.loadMoreButton.disabled = false;
          this.handleLoadingState(false);
        });
    }
  }

  handleLoadingState (isLoading, loadingNextpage) {
    if (isLoading) {
      if (loadingNextpage) {
        if (this.skeletonBottomLoader) {
          this.skeletonBottomLoader.classList.remove('hide');
        }
      } else {
        if (this.skeletonTopLoader) {
          this.skeletonTopLoader.classList.remove('hide');
        }
      }
    } else {
      if (this.skeletonTopLoader) {
        this.skeletonTopLoader.classList.add('hide');
      }

      if (this.skeletonBottomLoader) {
        this.skeletonBottomLoader.classList.add('hide');
      }
    }
  }

  onLoadMoreClick(event) {
    event.preventDefault();
    if (this.loading || !this.inputNextUrl.value) return;
    const nextUrlParams = this.inputNextUrl.value.split('?')[1];
    this.renderPage(nextUrlParams);
  }

}

paginationLoader.paginationData = [];
paginationLoader.urlParamsInitial = window.location.search.slice(1);
paginationLoader.urlParamsPrev = window.location.search.slice(1);
customElements.define('pagination-loader', paginationLoader);

window.addEventListener('popstate', () => {
  if (typeof FacetFiltersForm === 'undefined' && document.querySelector('pagination-loader')) window.location.reload();
});
